import Navbar from "../components/Navbar";
import Footer from '../components/Footer';
import BackToTop from '../components/BackToTop';
import PageHeader from "../components/PageHeader";
import DeitiesPage from "../components/DeitiesPage";

export default function RadhaGopinath() {
    return (
        <>
            <Navbar />
            <PageHeader title="The Abode of Sri Radha Gopinath" path="/radhagopinath" name="Radha Gopinath" />
            <DeitiesPage />
            <Footer />
            <BackToTop />
        </>
    );
}